import { Helmet, HelmetProvider } from 'react-helmet-async';
import { v4 as uuidv4 } from 'uuid';

export const CookieBot = () => {
  const nonce = uuidv4();

  if (
    process.env.REACT_APP_ENV === 'test' ||
    process.env.REACT_APP_ENV === 'production'
  ) {
    return (
      <HelmetProvider>
        <Helmet>
          <meta
            httpEquiv="Content-Security-Policy"
            content={`script-src 'nonce-${nonce}' 'strict-dynamic'`}
          />
          <script
            id="Cookiebot"
            src="https://consent.cookiebot.com/uc.js"
            data-cbid={
              process.env.REACT_APP_ENV === 'test'
                ? '026f24e1-1295-4845-ad14-6dd8f0cd59d0'
                : '5919d480-d869-42d1-9d12-08c718cc80f4'
            }
            data-blockingmode="auto"
            type="text/javascript"
            nonce={nonce}
          />
        </Helmet>
      </HelmetProvider>
    );
  }
  return null;
};
